const defaultFamilyMap = {
  breach: 'identity',
  breach_plus: 'identity',
  identity: 'identity',
};

export default (family, familyMap = defaultFamilyMap) => familyMap[family] || family;
